import makeStyles from "@mui/styles/makeStyles";
import colours from "Styles/colours";

const textAlign = {
  alignItems: "center",
  margin: "1rem",
  textAlign: "center",
};

const buttonStyles = {
  marginRight: "0.5rem",
};
export const useStyles = makeStyles((theme) => ({
  smallPrimaryButton: {
    marginRight: "0.5rem",
  },
  buttonFitContent: {
    ...buttonStyles,
    width: "fit-content",
    marginLeft: "0.5rem",
    padding: "0.5rem",
    "&:first-child": {
      marginBottom: "1rem",
    },
  },
  graphCard: {
    flex: "1",
    minWidth: "500px",
    height: "40rem",
    "&.MuiCard-root": {
      overflow: "overlay",
    },
  },
  textCenter: {
    ...textAlign,
  },
  textCenterWithBackground: {
    ...textAlign,
    backgroundColor: "#41A6F7",
    color: "#fff",
  },
  createNew: {
    height: "2.4rem",
    marginLeft: "0.6rem",
    textTransform: "none",
  },
  activeBtn: {
    marginLeft: "0px !important",
    backgroundColor: "#41A6F7 !important",
    color: "#fff !important",
    width: "5rem",
    height: "2.4rem",
    borderRadius: "5%",
    border: "1px solid #41A6F7",
    cursor: "pointer",
  },
  outlinePrimary: {
    marginLeft: "0px !important",
    color: "#41A6F7",
    borderColor: "#41A6F7",
    width: "5rem",
    height: "2.4rem",
    borderRadius: "5%",
    border: "1px solid #41A6F7",
    cursor: "pointer",
  },
  btnGroup: {
    position: "relative",
    display: "inline-flex",
    cursor: "pointer",
  },
  addIcon: {
    backgroundColor: "#41a6f7",
    color: "white",
    "&:hover": {
      backgroundColor: "#41a6f7",
    },
  },
  buttonDiv: {
    textAlign: "center",
    marginTop: 20,
  },
  scaleUpDownBtn: {
    marginLeft: "0.5rem",
    marginRight: "0.5rem",
  },
  hyperLink: {
    cursor: "pointer",
    fontWeight: "bold",
    color: "darkblue",
    textDecoration: "underline",
  },
  iconBlue: {
    fontSize: theme.typography.pxToRem(25),
    color: theme.palette.primary.main,
    marginTop: "-5px",
    cursor: "pointer",
  },
  reviewIcon: {
    fontSize: theme.typography.pxToRem(25),
    color: theme.palette.primary.main,
    marginTop: "8px",
    cursor: "pointer",
  },
  secondaryHeading: {
    fontSize: "20px",
    fontWeight: 600,
  },
  heading: {
    alignItems: "center",
    display: "flex",
    marginBottom: "1.5rem",
    whiteSpace: "nowrap",
  },
  dFlex: {
    alignItems: "center",
    display: "flex",
    margin: "0.5rem 0",
  },
  TextField: {
    width: "100%",
    "& .MuiFormControl-root": {
      width: "100 %",
    },
    "& .MuiInputBase-input": {
      padding: "10px",
    },
    marginBottom: "1rem",
  },
  legend: {
    fontSize: "0.8rem",
    color: "#727c87",
  },
  smallButtonDiv: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  // Dialog box styles
  content: {
    padding: "0",
  },
  dialog: {
    "& .MuiDialog-paperWidthLg": {
      overflowY: "visible",
      position: "absolute",
    },
  },
  contentBody: {
    overflowY: "visible",
  },
  // store swap table styles
  resultContainer: {
    display: "flex",
    justifyContent: "space-between",
  },
  tableLayout: {
    width: "45%",
  },
  formWidth: {
    width: "60%",
    marginBottom: "15px",
  },
  typographyMarginBottom: {
    marginBottom: "20px",
  },
  receiptDrawerButton: {
    marginTop: "60px",
    minWidth: "45px",
    maxWidth: "45px",
    boxShadow: "0 1px 15px 1px rgba(62, 57, 107, 0.17)",
    height: "50px",
    position: "fixed",
    zIndex: "500",
    right: 0,
    borderRadius: "50%",
    transform: "translateY(-50%)",
    textAlign: "center",
    paddingTop: "10px",
    marginRight: "50px",
  },
  bopButton: {
    marginTop: "175px",
    marginRight: "50px",
  },
  nonLinearButton: {
    marginTop: "120px",
    marginRight: "50px",
  },
  receiptDrawerButtonEnabled: {
    background: theme.palette.primary.main,
    cursor: "pointer",
    color: "#fff",
  },
  receiptDrawerButtonDisabled: {
    color: "#ffffff !important",
    background: "grey !important",
    pointerEvents: "none",
  },
  dialogGrid: { width: "100%", padding: "0 10px", marginBottom: "1rem" },
  planFinalizeHeaderContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  planFinalizeFormContainer: {
    width: "65%",
    marginBottom: "10px",
    "& .dropdown-height": {
      "& .ScrollCheck": {
        maxHeight: "8rem",
      },
    },
    "& .dropdown-multi-height": {
      "& .ScrollCheck": {
        maxHeight: "5rem",
      },
    },
  },
  secondaryLabel: {
    color: "#9299A2",
    marginBottom: "0.3rem",
  },
  actionIcon: {
    padding: "0px",
  },
  assortSingleFilterView: {
    paddingLeft: "32px",
    "& .dropdown-height": {
      height: "12.5rem",
      overflow: "auto",
      "& .ScrollCheck": {
        maxHeight: "10rem",
      },
    },
  },
  assortMultiFilterView: {
    paddingLeft: "32px",
    "& .dropdown-height": {
      height: "12.5rem",
      overflow: "auto",
      "& .ScrollCheck": {
        maxHeight: "7.5rem",
      },
    },
  },
  rightAlignButtonAssort: {
    textAlign: "right",
    marginBottom: "1rem",
    marginTop: "1rem",
  },
  depthMultiplierDivContainer: {
    width: "80%",
    margin: "0 auto",
  },
  inputGroup: {
    marginBottom: theme.spacing(1),
  },
  emptyDiv: {
    marginRight: "15rem",
  },
  filtersCont: {
    display: "flex",
  },
  dashboardFilterContainer: {
    display: "flex",
  },
  dashboardFiltersBtnsDiv: {
    display: "flex",
    alignSelf: "end",
    marginLeft: "15px",
    marginTop: "20px",
    justifyContent: "flex-end",
  },
  filterContainer: {
    marginBottom: "20px",
  },
  depthChoiceFlex: {
    display: "flex",
    gap: "2rem",
  },
  clusterNotes: {
    color: theme.palette.primary.main,
  },
  cardGrid: {
    width: "130%",
  },
  headerDiv: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "1rem",
  },
  paperStyle: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  createBtn: {
    padding: theme.typography.pxToRem(10),
    borderRadius: "50%",
    minWidth: "auto",
  },
  createLabel: {
    marginTop: 5,
    fontSize: 20,
  },
  centerBtn: {
    justifyContent: "center !important",
  },
  marginBottom15: {
    marginBottom: "15px",
  },
  marginTop10: {
    marginTop: "30px",
  },
  bottomButtonDiv: {
    marginTop: "30px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  bottomButton: {
    marginLeft: "10px",
    marginRight: "10px",
  },
  button: {
    marginRight: 5,
  },
  omniMappingFilterDiv: {
    justifyContent: "space-between",
    display: "flex",
    margin: "1rem",
  },
  omniMappingFilter: {
    display: "flex",
    flexWrap: "wrap",
    margin: "0 1rem",
    whiteSpace: "break-spaces",
  },
  omniMappingFilterRow: {
    display: "flex",
    flexDirection: "row",
  },
  choiceHeading: {
    display: "flex",
    justifyContent: "space-between",
    margin: "30px 0px",
  },
  choiceBtnAlignRight: {
    float: "right",
  },
  choiceActionDiv: {
    marginBottom: "70px",
    marginTop: "15px",
  },
  choiceLabel: {
    fontWeight: "600",
    fontSize: "1.05rem",
    marginTop: "2rem",
  },
  choiceTable: {
    zIndex: "1",
    position: "relative",
  },
  packFilter: {
    display: "flex",
    "& input": {
      height: "1rem",
      padding: "10px 14px",
    },
  },
  createSetOptDiv: {
    border: "1px solid #eaeef3",
    borderRadius: 5,
    background: "#f9fafc",
    paddingTop: 8,
    paddingBottom: 8,
    textAlign: "center",
    "&:hover": {
      cursor: "pointer",
    },
  },
  createSetOptText: {
    marginLeft: 5,
  },
  switchContainer: {
    display: "flex",
    alignItems: "center",
    "& > span": {
      marginRight: theme.typography.pxToRem(5),
    },
  },
  ORTextGrid: {
    display: "flex",
    alignSelf: "center",
    justifyContent: "center",
  },
  searchGrid: {
    display: "flex",
    flexDirection: "row",
  },
  ORText: {
    color: theme.palette.colours.filterLabelColor,
  },
  rightEnd: {
    marginLeft: "auto",
    display: "flex",
    height: "fit-content",
  },
  buttonFitMargin: {
    ...buttonStyles,
    width: "fit-content",
    marginLeft: "0.5rem",
    marginBottom: "1rem",
    padding: "0.5rem",
  },
  NLEFooter: {
    justifyContent: "space-between",
    margin: "0 20px",
  },
  deletePlanDiv: {
    width: "100%",
  },
  buyUnitsDivBackground: {
    backgroundColor: colours.navajoWhite,
  },
  formContainer: {
    width: "25%",
    marginLeft: "20px",
    marginBottom: "20px",
    "& .MuiInputLabel-root": {
      fontWeight: 700,
    },
    "& .dropdown-height": {
      "& .ScrollCheck": {
        maxHeight: "10rem",
      },
    },
    "& .dropdown-multi-height": {
      "& .ScrollCheck": {
        color: "yellow",
        maxHeight: "3.5rem",
      },
    },
  },
  closeIcon: {
    position: "absolute",
    right: 10,
    top: 8,
  },
  scaleBtn: {
    display: "flex",
    justifyContent: "end",
    margin: "inherit",
  },
  depthTableWidth: {
    margin: `0 ${theme.typography.pxToRem(50)}`,
  },
  inputLabel: {
    display: "flex",
    lineHeight: "normal",
    minHeight: "1rem",
    color: theme.palette.colours.filterLabelColor,
    lineHeight: "1.6",
    letterSpacing: "0px",
    opacity: 1,
    fontSize: "0.80rem",
    paddingBottom: "0.4rem",
    "& span:nth-child(1)": {
      maxWidth: "90%",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    "& span:nth-child(2)": {
      maxWidth: "10%",
    },
    merginRight: "10px"
  },
  typographyMarginTop: {
    marginTop: "0.5rem",
  },
  tableWidth: {
    margin: `0 ${theme.typography.pxToRem(250)}`,
  },
  chartComponent: {
    display: "flex",
    flexWrap: "wrap",
    gap: "2rem",
  },
  paperStyleCreate: {
    border: "1px solid #e3ecf4",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "fit-content",
  },
  iconDisabled: {
    fontSize: theme.typography.pxToRem(14),
    margin: "0 0.5rem",
    color: theme.palette.text.disabled,
    cursor: "pointer",
  },
  tableBtn: {
    marginBottom: "4px",
  },
  flexRow: {
    display: "flex",
    flexDirection: "row",
  },
  tickerText: {
    fontStyle: "italic",
    marginRight: "1rem",
    color: theme.palette.textColours.slateGrayLight,
  },
  divMargin: {
    margin: "1rem",
    width: "260px",
  },
  iconPadding: {
    padding: "10px",
  },
  metricsContainer: {
    display: "flex",
    justifyContent: "flex-start",
    paddingBottom: "20px"
  },
  filtersContainer: {
    padding: "20px"
  },
  kpiCardContainer: {
    margin: "1rem 0.5rem",
    padding: "1rem",
    width: "100%",
    height: "100%",
    boxShadow: "0px 0px 2px 2px rgba(0,0,0,0.2)"
  },
  kpiGridItem: {
    display: "grid",
  },
  kpiBorder: {
    borderRight: `1px solid ${theme.palette.colours.checboxBorder}`,
  },
  kpiHeading: {
    fontSize: "0.9rem", 
    fontWeight: "bold",
    margin: "1rem 0.5rem"
  },
  kpiLabel: {
    color: theme.palette.textColours.slateGrayLight,
    fontSize: "0.9rem",
    marginBottom: "0.5rem",
    textAlign: "center"
  },
  kpiSubValue: {
    fontSize: "1rem",
    fontWeight: "500",
    textAlign: "center"
  },
}));
